"use client";
import React from "react";
import Image from "next/image";
import Icon from "@/components/icons/Icons";
import { useLoginModal } from "@/utils/useLoginModal";
import { ROOT_URL } from "@/utils/gloableVariables";

export default function BestFundsStripV2() { 
  const { open, isLoggedIn, setModalKey } = useLoginModal();

  const handleClick = () => {
    if (!isLoggedIn) {
      open();
      setModalKey("rolling-page-bestFund-strip");
    }
  };

  const Component = isLoggedIn ? "a" : "button";

  return (
    <div className="relative overflow-hidden bg-[radial-gradient(160.5%_959.12%_at_-27.33%_50%,#11182ccc_0%,#420c7ecc_49.04%,#11182ccc_100%)] rounded-4xl sm:rounded-6xl flex flex-col xs:flex-row p-5 xs:p-0">
      <div className="xs:p-5 sm:p-8 mb-6 xs:mb-0 max-w-3xl">
        <div className="text-[#dadada] text-semibold text-xl sm:text-2xl md:text-3xl text-center xs:text-left leading-1.3! mb-5">
          Discover <span className="text-[#FD8735]">Top Mutual Funds</span> with <span className="text-[#FD8735]">AI-Powered</span> Rolling Returns
        </div>

        <Component {...(isLoggedIn ? { href: `${ROOT_URL}best-funds` } : { onClick: handleClick })} className="block relative w-fit leading-1.5 bg-white text-[#603790] font-semibold px-8 md:px-7 py-2 mx-auto xs:mx-0 rounded-xl shadow-[0_0_20px_4px_#ffffff4a] border-2 border-black/50">
          See My Top Funds
          <Image src="/next_assets/images/rolling-returns-pages/Snow.png" alt="snow" width={200} height={72} className="hidden xs:block h-18 z-0 absolute inset-x-0 -top-7 rotate-[-15deg] pointer-events-none" />
        </Component>
      </div>

      <div className="xs:pt-3.5 relative items-center gap-2 text-[#E0E0E0] sm:ml-auto">
        <div className="hidden xs:block translate-x-[32%] whitespace-nowrap ml-auto w-fit px-4.5 py-1.5 sm:py-2 text-sm sm:text-2sm sm:leading-5.5 bg-white rounded-s-full shadow-lg leading-1.3 text-center text-[#E0E0E0] mb-1.5 sm:mb-2">Investing in this fund would</div>

        <div className="hidden xs:block translate-x-[28%] whitespace-nowrap ml-auto w-fit px-4.5 py-1.5 sm:py-2.5 text-2sm sm:text-lg sm:leading-6.5 bg-white rounded-s-full shadow-lg leading-1.3 text-center text-[#E0E0E0] mb-3 sm:mb-4.5">Axis Mutual Fund gave almost</div>

        <div className="relative max-w-56 xs:max-w-none bg-white/25 p-1.5 sm:p-2 rounded-full xs:translate-x-[15%] z-1 mx-auto xs:mx-0">
          <div className="bg-white rounded-full px-2.5 sm:px-4.5 py-2 truncate text-xs xs:text-2sm sm:text-lg flex items-center gap-2.5 xs:gap-3 sm:gap-4.5 shadow-[-3.78px_-1.26px_6.3px_0px_#4D00A48C]">
            <Icon.stripStarIcon />
            <span className="inline-block w-3.5 h-3.5 sm:w-6 sm:h-6 border-l border-[#DDDDDD] pl-2.5 xs:pl-3 sm:pl-4.5 pr-6 shrink-0">Finding Mutual Funds...</span>
          </div>
          <Icon.stripCursorIcon className="absolute w-6 h-6 sm:w-9 sm:h-9 bottom-0 left-0 xs:-left-2 -translate-x-full -rotate-45" />
        </div>

        <Image src="/next_assets/images/rolling-returns-pages/Snow.png" alt="snow" width={200} height={80} className="absolute z-0 -rotate-45 left-14 bottom-2.5 opacity-40 md:opacity-70 pointer-events-none" />
      </div>
    </div>
  );
}
